const flatten = (obj: String[][]) => {
	return obj.reduce((a, b) => a.concat(b), []);
};

export default flatten;
